import FormHelperText from '@mui/material/FormHelperText';
import AsyncAutocomplete from './AsyncAutocomplete';
import { AUTOCOMPLETE_SEARCH_TYPE } from '../_const';

/**
 * Training Track search textbox
 * @param {string} key
 * @param {function} onchange
 * @param {function} onBlur
 * @param {boolean} error
 * @param {string} value
 * @param {string} name
 * @param {string} label
 * @param {boolean} disabled
 * @returns search textbox for training tracks
 */
const TrainingTrackAsyncAutocomplete = ({
	onchange,
	onBlur,
	error,
	value,
	name,
	id,
	label,
	helperText,
	disabled = false,
}) => {
	return (
		<>
			<AsyncAutocomplete
				type={AUTOCOMPLETE_SEARCH_TYPE.TRAINING_TRACK}
				label={label}
				placeholder='Search for Job Category'
				handleChange={value => {
					onchange(value);
				}}
				sx={{ flexGrow: 1 }}
				error={error}
				value={value?.label}
				name={name}
				id={id}
				onBlur={onBlur}
				disabled={disabled}
				isOptionEqualToValue={(option, value) =>
					option.label === value || option.label === value.label
				}
			/>

			<FormHelperText error={error}>
				{error
					? helperText && typeof helperText === 'string'
						? helperText
						: 'Invalid Input'
					: null}
			</FormHelperText>
		</>
	);
};

export default TrainingTrackAsyncAutocomplete;
